import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { UserRole } from '~/api/account/accountApiTypes';
import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { getAuthorByName } from '~/atomic/page/author/author.data';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { AuthorBlog } from '~/atomic/page/author/blog/AuthorBlog';
import { SCAuthorPage } from '~/atomic/page/author/styled';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { getAuthTokenFromServer } from '~/feature/authorization/getAuthToken';
import { AuthorTemplate } from '~/feature/template/AuthorTemplate';
import {
  createStore, RootState, useAppSelector,
} from '~/store';

const AuthorBlogPage:NextPage & LayoutType = () => {
  const { currentAuthor } = useAppSelector(authorSelector);

  const isEmpty = currentAuthor?.counters?.posts === 0;

  const description = `Блог автора ${currentAuthor?.name}`
  + ' на литературно-издательской площадке Bookriver'
  + ' Авторские посты ⭐ Серии произведений ⭐ Книги полностью'
  + ' ⭐ Скачать в формате fb2 ✉ Находите романы интересующего'
  + ' вас писателя на нашем сайте и добавляйте к себе в библиотеку';

  const title = `Блог автора ${
    currentAuthor?.name} |  Читать онлайн посты и книги полностью`;

  return (
    <PageTemplate
      isPublic={pagesConfigStore.authorBlog.isPublic}
      seo={{
        title,
        description,
        image: currentAuthor?.photoUrl,
        canonical: pagesConfigStore.authorBlog.as(currentAuthor.username),
        customSeoTags: (
          <>
            {isEmpty && (
              <meta name="robots" content="noindex, nofollow" />
            )}
          </>
        ),
      }}
      content={(
        <SCAuthorPage>
          <AuthorBlog />
        </SCAuthorPage>
      )}
    />
  );
};

AuthorBlogPage.getLayout = (page) => (
  <AuthorTemplate>{ page }</AuthorTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ authorUsername: string; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  await checkAuthToken(context, dispatch);
  const token = getAuthTokenFromServer(context);

  const authorUsername = context.params?.authorUsername ?? '';

  try {
    await dispatch(getAuthorByName({ username: authorUsername, token }));

    const state = store.getState();

    const { author: { currentAuthor } } = state;

    if (!currentAuthor?.id || !currentAuthor?.counters?.posts) {
      return { notFound: true };
    }

    if (currentAuthor.role !== UserRole.author) {
      return {
        redirect: {
          destination: pagesConfigStore.user.as(currentAuthor.username),
          permanent: false,
        },
      };
    }
    return { props: { state } };
  } catch (error) {
    console.log('error on blog page', { error });
    const state = store.getState();
    return { props: { state } };
  }
};

export default AuthorBlogPage;
